import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ImmutablePropTypes from 'react-immutable-proptypes'
import ImmutablePureComponent from 'react-immutable-pure-component'
import isObject from 'lodash/isObject'
import { withRouter } from 'react-router-dom'
import {
	changeGroupTitle,
	changeGroupPassword,
	changeGroupDescription,
	changeGroupCoverImage,
	changeGroupId,
	changeGroupCategory,
	changeGroupIsPrivate,
	changeGroupIsVisible,
	changeGroupIsAdminsVisible,
	changeGroupIsMembersVisible,
	changeGroupIsMediaVisible,
	changeGroupIsLinksVisible,
	changeGroupIsModerated,
	changeGroupAllowQuotes,
	submit,
	setGroup,
	resetEditor,
} from '../actions/group_editor'
import {
	closeModal, openModal,
} from '../actions/modal'
import { fetchGroup } from '../actions/groups'
import { fetchGroupCategories } from '../actions/group_categories'
import { isPro, me } from '../initial_state'
import ColumnIndicator from '../components/column_indicator'
import Button from '../components/button'
import Divider from '../components/divider'
import Input from '../components/input'
import Text from '../components/text'
import DisplayName from '../components/display_name'
import Switch from '../components/switch'
import Select from '../components/select'
import Textarea from '../components/textarea'
import FileInput from '../components/file_input'
import Avatar from '../components/avatar'
import Icon from '../components/icon'
import GroupPreview from '../components/previews/group_preview'
import { MODAL_PRO_UPGRADE } from '../constants'

class GroupCreate extends ImmutablePureComponent {

	state = {
		isMoreVisible: false,
	}

	componentDidMount() {
		const { groupId, group, showForm } = this.props

		this.props.onFetchGroupCategories()

		if (!group) {
			if (groupId) {
				this.props.onFetchGroup(groupId)
			} else if (!showForm) {
				this.props.onResetEditor()
			}
		} else {
			this.props.onSetGroup(group)
		}
	}

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.group !== nextProps.group && !!nextProps.group) {
      this.props.onSetGroup(nextProps.group)
    }
  }

	handleCoverImageChange = (e) => {
		try {
      this.props.onCoverImageChange(e.target.files[0])
    } catch (error) {
     // 
    }
	}

	handleOnToggleIsMoreVisible = () => {
		this.setState({ isMoreVisible: !this.state.isMoreVisible })
	}

	handleSubmit = (e) => {
		e.preventDefault()
		if (this.props.onClose) this.props.onClose()

		this.props.onSubmit(this.props.history)
	}

	render() {
		const {
			group,
			error,
			account,
			titleValue,
			descriptionValue,
			passwordValue,
			coverImage,
			onTitleChange,
			onChangeGroupPassword,
			onDescriptionChange,
			onChangeGroupId,
			onChangeGroupCategory,
			onChangeGroupIsPrivate,
			onChangeGroupIsVisible,
			onChangeGroupIsAdminsVisible,
			onChangeGroupIsMembersVisible,
			onChangeGroupIsMediaVisible,
			onChangeGroupIsLinksVisible,
			onChangeGroupIsModerated,
			onChangeGroupAllowQuotes,
			isSubmitting,
			onSubmit,
			idValue,
			category,
			isPrivate,
			isVisible,
			isAdminsVisible,
			isMediaVisible,
			isLinksVisible,
			isMembersVisible,
			isModerated,
			groupId,
			categories,
			isAdmin,
			allowQuotes,
			showForm,
		} = this.props
		const { isMoreVisible } = this.state
		
		if (!showForm) return <GroupPreview />

		if (!group && groupId) {
			return <ColumnIndicator type='loading' />
		} else if ((!group && error) || (groupId && !isAdmin)) {
			return <ColumnIndicator type='missing' />
		}

		const memberCount = group ? group.get('member_count') : 0
		const hasGroupSlug = group ? !!group.get('slug') : false
		let categoriesOptions = [{'title':'',value:''}]
		if (categories) {
			for (let i = 0; i < categories.count(); i++) {
				const c = categories.get(i)
				categoriesOptions.push({
					title: c.get('text'),
					value: c.get('id'),
				})
			}
		}

		const submitDisabled = ((!titleValue || !category || !descriptionValue) && !groupId) || isSubmitting

		return (
			<div className={[_s.d, _s.w100PC].join(' ')}>
				<div className={[_s.d, _s.flexRow, _s.mb10, _s.pb10, _s.pt10].join(' ')}>
					<Avatar size={38} account={account} />
					<div className={[_s.d, _s.pl15].join(' ')}>
						<DisplayName account={account} noUsername />
						<Text className={_s.pt2} size='small' color='tertiary'>Admin</Text>
					</div>
				</div>
				
				<FileInput
					disabled={isSubmitting}
					id='group-cover-photo'
					title={coverImage === null ? 'Cover image' : 'Cover image selected'}
					onChange={this.handleCoverImageChange}
					file={group ? group.get('cover_image_url') : undefined}
					width='100%'
					height='136px'
					isBordered
				/>
				<Text className={[_s.mt5, _s.mb15, _s.pb5].join(' ')} size='small' color='tertiary'>
					Max: 5MB. Accepted image types: .jpg, .png
				</Text>
				
				<div className={[_s.d, _s.w100PC, _s.mb10].join(' ')} />

				<Input
					id='group-title'
					title='Title *'
					value={titleValue}
					onChange={onTitleChange}
					disabled={isSubmitting}
					placeholder='New group title...'
					isRequired
				/>

				<Divider isInvisible />

				{
					memberCount >= 50 && !hasGroupSlug &&
					<React.Fragment>
						<Input
							id='group-id'
							title='Unique id'
							value={idValue}
							onChange={onChangeGroupId}
							disabled={isSubmitting}
						/>
						<Text className={[_s.mt5, _s.pl15]} size='small' color='secondary'>
							{
								!!idValue &&
								<b>g/{idValue}&nbsp;–&nbsp;</b>
							}
							A unique id that links to this group. (Cannot be changed)
						</Text>

						<Divider isInvisible />
					</React.Fragment>
				}

				<Textarea
					title='Description *'
					value={descriptionValue}
					onChange={onDescriptionChange}
					placeholder='This group is about...'
					disabled={isSubmitting}
					className={_s.minH40PX}
					isRequired
				/>

				<Divider isInvisible />			

				<div className={_s.d}>
					<Text className={[_s.mb10, _s.pb5].join(' ')} size='small' weight='medium' color='secondary'>
						Category *
					</Text>
					<Select
						value={category}
						onChange={onChangeGroupCategory}
						options={categoriesOptions}
					/>

					<Divider isInvisible />
				</div>

				<Switch
					label='Private'
					id='group-isprivate'
					checked={isPrivate}
					onChange={onChangeGroupIsPrivate}
					subtitle='Only members can see group posts.'
					labelProps={{
						weight: 'medium',
						color: 'secondary',
					}}
				/>

				<Divider isInvisible />
				
				<div className={[_s.d, _s.w100PC, _s.borderTop1PX, _s.borderColorSecondary, _s.pt15, _s.pb5].join(' ')}>
					<button
						onClick={this.handleOnToggleIsMoreVisible}
						className={[_s.d, _s.w100PC, _s.flexRow, _s.py5, _s.aiCenter, _s.mt5, _s.bgTransparent, _s.cursorPointer, _s.outlineNone].join(' ')}
					>
						<Text size='large' weight='medium' className={_s.mrAuto}>More options</Text>
						<Icon id='angle-right' className={_s.cPrimary} />
					</button>
				</div>
				
				<div className={isMoreVisible ? [_s.d, _s.w100PC, _s.pt15].join(' ') : [_s.d, _s.displayNone].join(' ')}>
					<Input
						id='group-password'
						title='Password'
						value={passwordValue}
						onChange={onChangeGroupPassword}
						disabled={isSubmitting}
					/>
					<Text className={[_s.mt5, _s.mb15, _s.pb5].join(' ')} size='small' color='tertiary'>
						(Optional) Add a password to restrict access to this group. This password is NOT encrypted and is only visible to group admins.
					</Text>

					<Divider />
					
					<div className={[_s.d, _s.pl5].join(' ')}>					
						<Switch
							label='Visible'
							id='group-isvisible'
							checked={isVisible}
							onChange={onChangeGroupIsVisible}
							subtitle='Anyone can find a visible group when searching Gab.'
							labelProps={{
								weight: 'medium',
								color: 'secondary',
							}}
						/>
		
						<Divider isInvisible />

						<Switch
							label='Moderated'
							id='group-ismoderated'
							checked={isModerated}
							subtitle='Posts from new & potentially spammy users will require moderator review.'
							onChange={onChangeGroupIsModerated}
							labelProps={{
								weight: 'medium',
								color: 'secondary',
							}}
						/>

						<Divider isInvisible />
							
						<Switch
							label={'Admins visible'}
							id='group-is-admins-visible'
							subtitle='Allow the admins of the group to be visible'
							checked={isAdminsVisible}
							onChange={onChangeGroupIsAdminsVisible}
							labelProps={{
								weight: 'medium',
								color: 'secondary',
							}}
						/>

						<Divider isInvisible />
							
						<Switch
							label={'Members visible'}
							id='group-is-members-visible'
							subtitle='Allow the members of the group to be visible'
							checked={isMembersVisible}
							onChange={onChangeGroupIsMembersVisible}
							labelProps={{
								weight: 'medium',
								color: 'secondary',
							}}
						/>

						<Divider isInvisible />

						<Switch
							label='Allow quote posts'
							id='group-allow-quotes'
							subtitle='Allow posts in this group to be quote posted'
							checked={allowQuotes}
							onChange={onChangeGroupAllowQuotes}
							labelProps={{
								weight: 'medium',
								color: 'secondary',
							}}
						/>

						<Divider isInvisible />
							
						<Switch
							label='Media visible'
							id='group-is-media-visible'
							subtitle='Allow the media posted by members of the group to be visible'
							checked={isMediaVisible}
							onChange={onChangeGroupIsMediaVisible}
							labelProps={{
								weight: 'medium',
								color: 'secondary',
							}}
						/>

						<Divider isInvisible />
							
						<Switch
							label='Links visible'
							id='group-is-links-visible'
							subtitle='Allow the links posted by members of the group to be visible'
							checked={isLinksVisible}
							onChange={onChangeGroupIsLinksVisible}
							labelProps={{
								weight: 'medium',
								color: 'secondary',
							}}
						/>

					</div>
				</div>
				
				<div className={[_s.d, _s.borderTop1PX, _s.borderColorSecondary, _s.mt15, _s.py15, _s.bgPrimary].join(' ')}>
					<Button
						radiusSmall
						isDisabled={submitDisabled}
						onClick={this.handleSubmit}
						className={_s.mt15}
					>
						<Text color='inherit' align='center' size='medium' weight='medium'>
							{!!group ? 'Update' : 'Create'}
						</Text>
					</Button>
				</div>
			</div>
		)
	}

}

const mapStateToProps = (state, { groupId: propsGroupId, params, showForm }) => {
	const groupId = propsGroupId || isObject(params) ? params['id'] : null
	const group = state.getIn(['groups', groupId])
	let isAdmin = false

	if (groupId) {
		const relationships = state.getIn(['group_relationships', groupId])
		if (relationships) {
			isAdmin = relationships.get('admin')
		}
	}

	if (!showForm) {
		return {
			// 
		}
	}

	return {
		group,
		groupId,
		isAdmin,
		account: state.getIn(['accounts', me]),
		error: (groupId && !group) || (group && !isAdmin),
		titleValue: state.getIn(['group_editor', 'title']),
		passwordValue: state.getIn(['group_editor', 'password']),
		descriptionValue: state.getIn(['group_editor', 'description']),
		coverImage: state.getIn(['group_editor', 'coverImage']),
		isSubmitting: state.getIn(['group_editor', 'isSubmitting']),
		idValue: state.getIn(['group_editor', 'id']),
		category: state.getIn(['group_editor', 'category']),
		isPrivate: state.getIn(['group_editor', 'isPrivate']),
		isVisible: state.getIn(['group_editor', 'isVisible']),
		isAdminsVisible: state.getIn(['group_editor', 'isAdminsVisible']),
		isMediaVisible: state.getIn(['group_editor', 'isMediaVisible']),
		isLinksVisible: state.getIn(['group_editor', 'isLinksVisible']),
		isMembersVisible: state.getIn(['group_editor', 'isMembersVisible']),
		isModerated: state.getIn(['group_editor', 'isModerated']),
		categories: state.getIn(['group_categories', 'items']),
		allowQuotes: state.getIn(['group_editor', 'allowQuotes']),
	}
}

const mapDispatchToProps = (dispatch) => ({
	onTitleChange(value) {
		dispatch(changeGroupTitle(value))
	},
	onDescriptionChange(value) {
		dispatch(changeGroupDescription(value))
	},
	onChangeGroupPassword(value) {
		dispatch(changeGroupPassword(value))
	},
	onCoverImageChange(imageData) {
		dispatch(changeGroupCoverImage(imageData))
	},
	onChangeGroupId(value) {
		dispatch(changeGroupId(value))
	},
	onChangeGroupCategory(e) {
		dispatch(changeGroupCategory(e.target.value))
	},
	onChangeGroupIsPrivate(checked) {
		dispatch(changeGroupIsPrivate(checked))
	},
	onChangeGroupIsVisible(checked) {
		dispatch(changeGroupIsVisible(checked))
	},
	onChangeGroupIsAdminsVisible(checked) {
		dispatch(changeGroupIsAdminsVisible(checked))
	},
	onChangeGroupIsMediaVisible(checked) {
		dispatch(changeGroupIsMediaVisible(checked))
	},
	onChangeGroupIsLinksVisible(checked) {
		dispatch(changeGroupIsLinksVisible(checked))
	},
	onChangeGroupAllowQuotes(checked) {
		dispatch(changeGroupAllowQuotes(checked))
	},
	onChangeGroupIsMembersVisible(checked) {
		dispatch(changeGroupIsMembersVisible(checked))
	},
	onChangeGroupIsModerated(checked) {
		dispatch(changeGroupIsModerated(checked))
	},
	onResetEditor() {
		dispatch(resetEditor())
	},
	onSetGroup(group) {
		dispatch(setGroup(group))
	},
	onSubmit(routerHistory) {
		dispatch(submit(routerHistory))
		dispatch(closeModal())
	},
	onFetchGroup(groupId) {
		dispatch(fetchGroup(groupId))
	},
	onFetchGroupCategories() {
		dispatch(fetchGroupCategories())
	},
})

GroupCreate.propTypes = {
	group: ImmutablePropTypes.map,
	titleValue: PropTypes.string.isRequired,
	descriptionValue: PropTypes.string.isRequired,
	coverImage: PropTypes.object,
	onTitleChange: PropTypes.func.isRequired,
	onDescriptionChange: PropTypes.func.isRequired,
	onChangeGroupId: PropTypes.func.isRequired,
	onChangeGroupPassword: PropTypes.func.isRequired,
	onChangeGroupCategory: PropTypes.func.isRequired,
	onChangeGroupIsPrivate: PropTypes.func.isRequired,
	onChangeGroupIsVisible: PropTypes.func.isRequired,
	onChangeGroupIsAdminsVisible: PropTypes.func.isRequired,
	onChangeGroupIsMembersVisible: PropTypes.func.isRequired,
	onChangeGroupIsMediaVisible: PropTypes.func.isRequired,
	onChangeGroupIsLinksVisible: PropTypes.func.isRequired,
	onChangeGroupIsModerated: PropTypes.func.isRequired,
	onFetchGroup: PropTypes.func.isRequired,
	onFetchGroupCategories: PropTypes.func.isRequired,
	onResetEditor: PropTypes.func.isRequired,
	onSetGroup: PropTypes.func.isRequired,
	onSubmit: PropTypes.func.isRequired,
	isSubmitting: PropTypes.bool,
	isAdmin: PropTypes.bool,
	onClose: PropTypes.func,
	idValue: PropTypes.string.isRequired,
	category: PropTypes.string.isRequired,
	isPrivate: PropTypes.bool.isRequired,
	isVisible: PropTypes.bool.isRequired,
	isModerated: PropTypes.bool.isRequired,
	categories: ImmutablePropTypes.list.isRequired,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GroupCreate))
